export default __webpack_public_path__ + "static/media/slide30.a644f75d.png";